// Paints instantly from cart:updated; the drawer's server re-render then corrects the money format.
(function () {
  if (customElements.get('gp-shipping-progress')) return;

  class GPShippingProgress extends HTMLElement {
    connectedCallback() {
      this._onUpdate = this._onUpdate.bind(this);

      if (window.cartState) {
        window.cartState.addEventListener('cart:updated', this._onUpdate);
        if (window.cartState.cart) this._onUpdate();
      }
    }

    disconnectedCallback() {
      if (window.cartState) window.cartState.removeEventListener('cart:updated', this._onUpdate);
    }

    _onUpdate() {
      const state = window.cartState && window.cartState.shippingProgress;
      if (!state || !state.threshold) return;

      const fill = this.querySelector('[data-gp-progress-fill]');
      const track = this.querySelector('[data-gp-progress-track]');
      const message = this.querySelector('[data-gp-progress-message]');

      if (fill) fill.style.width = `${state.percent}%`;
      if (track) track.setAttribute('aria-valuenow', String(state.percent));

      this.classList.toggle('gp-shipping-progress--met', state.met);
      this.dataset.gpReason = state.reason;

      if (!message) return;

      // innerHTML: merchant-authored copy contains markup; [amount] is formatted here from a number.
      message.innerHTML = state.met
        ? this._metCopy(state.reason)
        : this.dataset.messageAway.replace('[amount]', this._money(state.remaining));
    }

    // Liquid has already applied blank-to-generic fallbacks to these attributes.
    _metCopy(reason) {
      if (reason === 'largest_pack_subscription') return this.dataset.messageSubscription;
      if (reason === 'starter_pack_only') return this.dataset.messageStarter;
      return this.dataset.messageMet;
    }

    _money(pence) {
      const cart = (window.cartState && window.cartState.cart) || {};
      const currency = cart.currency || 'GBP';
      const locale = document.documentElement.lang || 'en-GB';

      try {
        return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(pence / 100);
      } catch (error) {
        return (pence / 100).toFixed(2);
      }
    }
  }

  customElements.define('gp-shipping-progress', GPShippingProgress);
})();
